export const logo = require('./logo.svg');
